import {Api} from './Api'
import {restApiConf} from './config'

export const restApi = new Api(restApiConf)

export * from './data-contracts'
export * from './http-client'
export * from './utils'
export * from './swr'
